import { PlansList } from '../types/subscription'
import {CompanyModel, CompanyEmployeeModel, CategoryModel, CriterionModel, Profile, SubscriptionModel} from './../types'

export const profile: Profile = {
    id: 1,
    email: "admin@admin.tes",
    firstname: "Admin",
    lastname: "Admin",
    tokenExpired: new Date().getTime() + 24 * 60 * 60 * 1000,
    token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9",
    locale: 'ru',
    company: {
        id: 1,
        name: "Text company"
    },
    isOwner: false,
    tutorialCompleted: true
}

export const plans: PlansList = {
    items: [
        {
            code: "BASE1",
            price: 3750.00,
            name: "Базовый"
        },
        {
            code: "OMPTIMAL1",
            price: 7500.00,
            name: "Оптимальный"

        },
        {
            code: "EXPERT1",
            price: 22500.00,
            name: "Эксперт"
        }
    ]
}

export const subscription: SubscriptionModel = {
    plan: {
        code: "BASE1",
        price: 2990.99
    },
    users: {
        totalActive: 11,
        max: 25
    },
    integrations: {
        totalActive: 2,
        max: 4
    },
    subscription: {
        startedAt: "2021-01-31",
        payedAt: "2021-01-31T23:59:59+00:00",
        payedTo: "2022-01-31",
        daysLeft: 365
    },
    callsEstimations: {
        max: 256,
        totalInPeriod: 123
    }
}

export const categoriesList: CategoryModel [] = [
    {
        id: 22,
        name: "Ford",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 23,
        name: "Nissan",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 24,
        name: "Renault",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 25,
        name: "Peugeot",
        status: 'INACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 26,
        name: "Toyota",
        status: 'INACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 27,
        name: "Chrysler",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 28,
        name: "Dodge",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    }
]

export const criterionsList: CriterionModel [] = [
    {
        id: 400001,
        name: "Предложил дополнительные товары",
        status: "ACTIVE",
        typeCode: "REQUIREMENT",
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 400002,
        name: "Предложил дополнительные услуги",
        status: "INACTIVE",
        typeCode: "REQUIREMENT",
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 400003,
        name: "Предложил дополнительную гарантию",
        status: "ACTIVE",
        typeCode: "REQUIREMENT",
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    }
]

export const companyList: CompanyModel [] = [
    {
        id: 22,
        name: "Ford",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 23,
        name: "Nissan",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 24,
        name: "Renault",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 25,
        name: "Peugeot",
        status: 'INACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 26,
        name: "Toyota",
        status: 'INACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 27,
        name: "Chrysler",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    },
    {
        id: 28,
        name: "Dodge",
        status: 'ACTIVE',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31"
    }
]

export const companyEmployeesList: CompanyEmployeeModel [] = [
    {
        email: 'demo@demo.com',
        id: 1,
        firstname: 'Иван',
        surname: 'Иванович',
        lastname: 'Иванов',
        //role: 'CONTROL',
        status: 'ACTIVE',
        locale: 'ru',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31",
        isOwner: true,
        phone: '+79114556677'
    },
    {
        email: 'demo2@demo.com',
        id: 2,
        firstname: 'Лидия',
        surname: 'Петровна',
        lastname: 'Сидорова',
        //role: 'OWNER',
        status: 'ACTIVE',
        locale: 'ru',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31",
        isOwner: false,
        phone: '+79114556677'
    },
    {
        email: 'demo3@demo.com',
        id: 3,
        firstname: 'Петр',
        surname: 'Петрович',
        lastname: 'Петров',
        //role: 'CONTROL',
        status: 'INACTIVE',
        locale: 'ru',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31",
        isOwner: false,
        phone: '+79114556677'
    },
    {
        email: 'demo4@demo.com',
        id: 4,
        firstname: 'Сидор',
        surname: 'Сидорович',
        lastname: 'Сидоров',
        //role: 'CONTROL',
        status: 'ACTIVE',
        locale: 'ru',
        createdAt: "2021-01-31",
        updatedAt: "2021-01-31",
        isOwner: false,
        phone: '+79114556677'
    }
]